import {CircularProgress, Stack, Typography} from '@mui/material';
import {useEffect, useState} from 'react';

const MESSAGE_DURATION = 2 * 1000; // 2 seconds

const MESSAGES = [
  'Powering up a space mission 🚀',
  'Pulling from the far reaches of the galaxy 🪐',
  'Consulting ancient star maps 💫',
  'Scanning for life forms 🛰️',
  'Running systems check on the mothership 🤖',
  'Synchronizing with planetary orbits 🪐',
  'Collecting cosmic dust ✨',
];

const OverviewLoadingMessage = () => {
  const randomMessageIndex = Math.floor(Math.random() * MESSAGES.length);
  const [messageIndex, setMessageIndex] = useState(randomMessageIndex);

  useEffect(() => {
    const intervalId = setInterval(
      () => setMessageIndex(state => (state + 1) % MESSAGES.length),
      MESSAGE_DURATION,
    );

    return () => clearInterval(intervalId);
  }, []);

  return (
    <Stack direction="row" sx={{alignItems: 'center', gap: 1.5}}>
      <CircularProgress aria-label="Data product loading spinner" size="16px" />
      <Typography variant="body2">{MESSAGES[messageIndex]}</Typography>
    </Stack>
  );
};

export default OverviewLoadingMessage;
